import { LinearGradient } from "expo-linear-gradient";
import { MotiView } from "moti";
import { ReactElement } from "react";
import React from "react";
import { Platform } from "react-native";
import { Easing } from "react-native-reanimated";

import { Box, HStack, Text, VStack } from "../../../../components/primitive";

export type SignedOutBannerProps = {
  position: "top" | "bottom";
  title?: string;
  subTitle?: string;
  actionButton?: ReactElement;
  isOpen?: boolean;
  onClose?: () => void;
};

export const SignedOutBanner = ({
  position = "top",
  isOpen,
  onClose,
  title,
  subTitle,
  actionButton,
}: SignedOutBannerProps) => {
  const borderTopRadius = position === "top" ? 0 : 16;
  const borderBottomRadius = position === "bottom" ? 0 : 16;

  return !isOpen ? null : (
    <Box
      style={{
        position: "absolute",
        top: position === "top" ? 0 : "auto",
        bottom: position === "bottom" ? 0 : "auto",
      }}
      alignItems="center"
      width="100%"
    >
      <Box width="100%" maxWidth={420}>
        <MotiView
          from={{
            transform: [{ translateY: position === "top" ? -100 : 100 }],
          }}
          animate={{
            transform: [{ translateY: "0px" }],
          }}
          transition={{
            translateY: {
              type: "timing",
              duration: 200,
              repeatReverse: false,
              easing: Easing.linear,
            },
          }}
        >
          <Box
            paddingHorizontal={0.5}
            paddingBottom={position === "top" ? 0.5 : 0}
            paddingTop={position === "bottom" ? 0.5 : 0}
            style={{
              maxWidth: 420,
              borderTopLeftRadius: borderTopRadius,
              borderTopRightRadius: borderTopRadius,
              borderBottomLeftRadius: borderBottomRadius,
              borderBottomRightRadius: borderBottomRadius,
            }}
          >
            <LinearGradient
              colors={
                position === "top"
                  ? ["#F1E5FF", "#BA82FA"]
                  : ["#BA82FA", "#F1E5FF"]
              }
              style={{
                borderTopLeftRadius: position === "top" ? 0 : 16,
                borderTopRightRadius: position === "top" ? 0 : 16,
                borderBottomLeftRadius: position === "bottom" ? 0 : 16,
                borderBottomRightRadius: position === "bottom" ? 0 : 16,
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                alignItems: "center",
                alignContent: "center",
                justifyContent: "space-around",
              }}
            />
            <HStack
              bg="surface-accent-pink-subtlest"
              style={{
                borderTopLeftRadius: position === "top" ? 0 : 14.5,
                borderTopRightRadius: position === "top" ? 0 : 14.5,
                borderBottomLeftRadius: position === "bottom" ? 0 : 14.5,
                borderBottomRightRadius: position === "bottom" ? 0 : 14.5,
              }}
              width="100%"
              height="100%"
              alignItems="center"
              justifyContent="space-between"
              padding={5}
              paddingBottom={
                position === "bottom" && Platform.OS !== "web" ? 10 : 5
              }
            >
              <VStack gap={1}>
                <Text variant="mainMicro" color="text-accent-pink-primary">
                  {subTitle}
                </Text>
                <Text variant="mainSmallSemiBold" color="text-primary">
                  {title}
                </Text>
              </VStack>
              {actionButton}
            </HStack>
          </Box>
        </MotiView>
      </Box>
    </Box>
  );
};
